module.exports = __webpack_public_path__ + "img/ntw_logo_adjust.037176cd.png";